import { Drawer, styled, Typography } from '@mui/material';
import { CustomerForm } from '@features/customers/components/forms/CustomerForm/CustomerForm';

interface CreateCustomerDrawerProps {
  open: boolean;
  onClose: () => void;
  onCustomerCreated?: (customerId: string) => void;
}

export const CreateCustomerDrawer = ({
  open,
  onClose,
  onCustomerCreated,
}: CreateCustomerDrawerProps) => {
  return (
    <Drawer anchor={'right'} open={open} onClose={onClose}>
      <SideDrawerContainer>
        <Header>
          <Typography variant="h5">{'Create Customer'}</Typography>
        </Header>
        <CustomerForm 
          handleClose={onClose} 
          onCustomerCreated={onCustomerCreated}
          createFromOrderView={true}
        />
      </SideDrawerContainer>
    </Drawer>
  );
};

const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 16px',
  height: '64px',
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const SideDrawerContainer = styled('div')(({ theme }) => ({
  width: '100vw',
  position: 'relative',
  height: '100%',
  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.up('lg')]: {
    width: '500px',
  },
}));

